import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Textarea } from 'components/Form/Input/Textarea/Textarea';

import { ConfirmActionModal } from '../ConfirmActionModal/ConfirmActionModal';

const REASON_MAX_LENGTH = 1000;

type ResendAsReceiverModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: (reason: string) => void;
  isLoading: boolean;
};

export const ResendAsReceiverModal = ({ open, setOpen, onConfirm, isLoading }: ResendAsReceiverModalProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  /**
   * This component sits outside the dialog it renders, so closing does not unmount it and a typed
   * reason would survive into the next open. Clearing on `open` covers both close paths: the cancel
   * button here and the success close driven by the action hook.
   */
  useEffect(() => {
    if (!open) {
      setReason('');
    }
  }, [open]);

  return (
    <ConfirmActionModal
      open={open}
      setOpen={setOpen}
      onConfirm={() => onConfirm(reason)}
      isLoading={isLoading}
      title={t('transactions:show.actionButtons.resendAsReceiverConfirmationModal.title')}
      description={t('transactions:show.actionButtons.resendAsReceiverConfirmationModal.description')}
      confirmLabel={t('transactions:show.actionButtons.resendAsReceiverConfirmationModal.confirm')}
      analyticsIdPrefix="resend_as_receiver"
    >
      <Textarea
        label={t('transactions:show.actionButtons.resendAsReceiverConfirmationModal.reasonLabel')}
        placeholder={t('transactions:show.actionButtons.resendAsReceiverConfirmationModal.reasonPlaceholder')}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
        maxLength={REASON_MAX_LENGTH}
        rows={3}
        disabled={isLoading}
      />
    </ConfirmActionModal>
  );
};
